/* eslint-disable security/detect-object-injection */
import React, { useContext, useState } from 'react';
import AnimatedPageFade from '../../components/Animations/AnimatedPageFade';
import AnimatedButton from '../../components/Button';
import BannerImage from './BannerImage';
import ApplicationContext from '../../context/ApplicationContext';
import Input from '../../components/Input';
import { handleToast, handleValidation } from '../../helpers/CommonFunctions';
import { dataService } from '../../services/data.service';
import ThreeDotsBlackLoader from '../../components/LoadingDots/ThreeDotsBlack';
import { authLanguageContent } from './authLanguageContent';
import { backNextLanguageContent } from '../../components/Button/backNextLanguageContent';

function NamePage(props) {
    const { handlePage, selectedLanguage, tempToken } = useContext(ApplicationContext);
    const [state, setState] = useState({
        first_name: '',
        last_name: '',
    });
    const [loading, setLoading] = useState(false);
    const [submitSelected, setSubmitSelected] =  useState(false);
    const [message, setMessage] = useState('');

    const handleSubmit = async () => {
        setSubmitSelected(true);
        setLoading(true);
        if(!handleValidation(state)) {
            setLoading(false);
            return;
        } else {
            const payload = {
                "first_name": state.first_name.trim(),
                "last_name": state.last_name.trim(),
            }
            dataService.verifyName(tempToken, payload).then((res) => {
                setLoading(false);
                if(res.error === false) {
                    handlePage('dobVerify');
                } else {
                    setMessage(res.data.data.message);
                }
            })
        }
    }

    return (
        <AnimatedPageFade className='flex flex-col justify-between relative h-welcome auth'>
            <div className='p-[8px]'>
                <p className={`text-center font-semibold text-[#64A003] text-[24px] border-b border-[#D7D7D7] py-[10px] lg:text-[26px] xl:text-[32px] 2xl:text-[38px] ${selectedLanguage === 'ar' ? 'dir-rtl' : ''}`}>{authLanguageContent['welcome'][selectedLanguage]}</p>
                <div>
                    <div className={`mt-[12px] ${selectedLanguage === 'ar' ? 'dir-rtl' : ''}`}>
                        {message !== '' && handleToast(authLanguageContent[message.toLowerCase().replaceAll(' ', '-')][selectedLanguage], 'error', setMessage, selectedLanguage)}
                        <div className="relative">
                            <Input handleRegex={false} setSubmitSelected={setSubmitSelected} message={message} setMessage={setMessage}
                                submitSelected={submitSelected} id="first_name" value={state.first_name} placeholder={authLanguageContent['enter-patient-first-name'][selectedLanguage]} 
                                setState={setState} labelName={authLanguageContent['patient-first-name'][selectedLanguage]} isMandatory={true}  />
                        </div>
                        <div className="relative mt-[15px]">
                            <Input handleRegex={false} setSubmitSelected={setSubmitSelected} message={message} setMessage={setMessage}
                                submitSelected={submitSelected} id="last_name" value={state.last_name} placeholder={authLanguageContent['enter-patient-last-name'][selectedLanguage]}
                                setState={setState} labelName={authLanguageContent['patient-last-name'][selectedLanguage]} isMandatory={true} />
                        </div>
                    </div>
                    <div className='flex justify-center mt-[59px]'>
                        <AnimatedButton disabled={(state.first_name.trim() === '' || state.last_name.trim() === '') || loading} 
                            handleClick={() => handleSubmit('dobVerify')} id="next_button" className={`font-semibold text-gray w-[200px] h-[40px] ${loading ? '' : 'pl-[41px]'} text-[16px] md:text-[18px] lg:text-[18px] xl:text-[18px] 2xl:text-[18px] justify-center`}>
                            {loading ? <ThreeDotsBlackLoader /> : backNextLanguageContent['next'][selectedLanguage]}
                            {!loading && <img src="/images/next.svg" alt="next" className='ml-[1.2em] w-[1.7em] h-[1.7em]' />}
                        </AnimatedButton>
                    </div>
                </div>
            </div>
            <BannerImage />
        </AnimatedPageFade>
    );
}

export default NamePage;